import { SubpageShell } from "@/components/layout/SubpageShell";
import { Contact } from "@/components/landing/Contact";

export default function ContactPage() {
  return (
    <div data-testid="contact-page">
      <SubpageShell titleZh="联系我们" titleEn="Contact Us" withFooter={false}>
        <Contact />
      </SubpageShell>
    </div>
  );
}
